<template lang="pug">
  .popup_base(v-if="show_popup")
    .main_box(:style="{maxHeight: maxHeight}")
      iframe(:src="frameUrl")
      .close_button(@click="close_popup")
</template>

<script lang="js">
export default {
  props: {
    frameUrl: {
      type: String,
      default: 'https://imasugu-souzoku.com/',
    },
    maxHeight: {
      type: String,
      default: '480px',
    },
  },

  data: () => ({
    show_popup: true,
  }),

  methods: {
    close_popup() {
      this.show_popup = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.popup_base
  position: fixed
  top: 0
  left: 0
  width: 100%
  height: 100%
  background-color: rgba(0, 0, 0, 0.8)
  display: flex
  justify-content: center
  align-items: center
  .main_box
    width: 90%
    height: 80%
    position: relative
    max-width: 1000px
    iframe
      border: none
      width: 100%
      height: 100%
      background-color: $white
    .close_button
      position: absolute
      right: -10px
      top: -10px
      width: 40px
      height: 40px
      background-color: $white
      border-radius: 200px
      border: solid 1px $light-black
      cursor: pointer
      &:before
        content: ""
        display: block
        border: solid 1px $light-black
        height: 2px
        width: 100%
        position: absolute
        top: 19px
        transform: rotate(45deg)
      &:after
        content: ""
        display: block
        border: solid 1px $light-black
        height: 2px
        width: 100%
        position: absolute
        top: 19px
        transform: rotate(-45deg)
</style>